import { GraficChart } from '../../containers/GraficChart'
import { useAuth } from '../../contexts/AuthContext'
import { Request } from '../../hooks/Request'
import { H1 } from '../../components/Text'
import Texto from '../../components/Text/Texto'
import { H3Custom } from '../../components/Text/H3'
import { formatDate } from '../../utils/validate'

const Summary = () => {
  const { user } = useAuth()
  return (
    <div className="p-[0px] sm:p-[20px]">
      {user?.company?.length === 0 ? null : (
        <div className="bg-white border-4 border-[#618BCC] rounded-md m-[10px] sm:m-[20px] p-[10px] sm:p-[20px] flex flex-col items-center">
          {user?.company?.length === 1 ? (
            <H1>INFORMACIÓN DE LA COMPAÑÍA</H1>
          ) : (
            <H1>INFORMACIÓN DE LAS COMPAÑÍAS</H1>
          )}
          {user?.company?.map((company, index) => (
            <CompanySection key={index} company={company} />
          ))}
        </div>
      )}
      <div className="bg-white m-[10px] sm:m-[20px] p-[10px] sm:p-[20px] border-4 border-[#618BCC] rounded-md flex flex-col items-center">
        <H1>INFORMACIÓN DE USUARIO</H1>
        <div className="w-full flex flex-wrap items-center border-t-4 border-[#618BCC] justify-items-center content-center sm:justify-between">
          <div className="flex flex-col items-center justify-items-center w-full sm:w-1/3 p-[15px] mx-auto my-[10px] sm:my-[15px]">
            <H3Custom className="font-semibold">NOMBRE</H3Custom>
            <Texto className="">{user?.user?.name}</Texto>
          </div>
          <div className="flex flex-col items-center justify-items-center w-full sm:w-1/3 p-[15px] mx-auto my-[10px] sm:my-[15px]">
            <H3Custom className="font-semibold">APELLIDO PATERNO</H3Custom>
            <Texto className="">{user?.user?.fatherLastName}</Texto>
          </div>
          <div className="flex flex-col items-center justify-items-center w-full sm:w-1/3 p-[15px] mx-auto my-[10px] sm:my-[15px]">
            <H3Custom className="font-semibold"> APELLIDO MATERNO</H3Custom>
            <Texto className="">{user?.user?.motherLastName}</Texto>
          </div>
          <div className="flex flex-col items-center justify-items-center w-full sm:w-1/3 p-[15px] mx-auto my-[10px] sm:my-[15px]">
            <H3Custom className="font-semibold">CARNET DE IDENTIDAD</H3Custom>
            <Texto className="">{user?.user?.ci}</Texto>
          </div>
          <div className="flex flex-col items-center justify-items-center w-full sm:w-1/3 p-[15px] mx-auto my-[10px] sm:my-[15px]">
            <H3Custom className="font-semibold"> Nro DE CELULAR </H3Custom>
            <Texto className="">{user?.user?.cellphoneNumber}</Texto>
          </div>
          <div className="flex flex-col items-center justify-items-center w-full sm:w-1/3 p-[15px] mx-auto my-[10px] sm:my-[15px]">
            <H3Custom className="font-semibold"> Nro DE TELEFONO </H3Custom>
            <Texto className="">
              {user?.user?.phoneNumber
                ? user.user.phoneNumber
                : 'No registrado'}
            </Texto>
          </div>
          <div className="flex flex-col items-center justify-items-center w-full sm:w-1/3 p-[15px] mx-auto my-[10px] sm:my-[15px]">
            <H3Custom className="font-semibold"> EMAIL </H3Custom>
            <Texto className="">{user?.user?.email}</Texto>
          </div>
        </div>
      </div>
    </div>
  )
}

const CompanySection = ({ company }) => {
  // const [valueSelect] = useState(25)
  const { data } = Request({
    urlApi: company.id
      ? `/clientStats/companies/${company.id}`
      : null,
  })

  // useEffect(() => {
  //   call()
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [valueSelect])

  if (data === undefined) return null

  return (
    <div className="flex w-full flex-col sm:flex-row items-center border-t-4 border-[#618BCC] py-[20px] sm:py-[20px]">
      <InfoEmpresa user={company} />
      <div className="w-[95%] sm:w-[40%] sm:border-l-4 border-[#618BCC] px-[20px] text-center font-semibold">
        <H3Custom className="font-semibold py-[20px] mb-4">CANTIDAD DE TRÁMITES POR GESTIÓN</H3Custom>
        <GraficChart values={company} />
      </div>
    </div>
  )
}

export default Summary

const InfoEmpresa = ({ user }) => {
  const { data } = Request({
    urlApi: user.id ? `company/${user?.id}/ClientsCompany` : null,
  })

  return (
    <div className="flex flex-col w-[95%] sm:w-[60%]">
      <div className="w-full flex flex-wrap items-center justify-items-center content-center sm:justify-between">
        <div className="flex flex-col items-center justify-items-center w-full lg:w-1/2 my-[10px] sm:my-[15px] p-[15px] mx-auto">
          <H3Custom className="font-semibold">RAZÓN SOCIAL</H3Custom>
          <Texto className="text-[#ca7b2b] font-semibold bg-[#F19E4D30] px-2 rounded-xl pb-1">{user?.razonSocial}</Texto>
        </div>
        <div className="flex flex-col items-center justify-items-center w-full lg:w-1/2 my-[10px] sm:my-[15px] p-[15px] mx-auto">
          <H3Custom className="font-semibold">NIT</H3Custom>
          <Texto className="">{user?.nit}</Texto>
        </div>
        <div className="flex flex-col items-center justify-items-center w-full lg:w-1/2 my-[10px] sm:my-[15px] p-[15px] mx-auto">
          <H3Custom className="font-semibold"> ESTADO</H3Custom>
          <Texto className={user?.status === "Activo" ? "text-green-600 bg-green-100 px-2 pb-1 rounded-xl font-semibold" : "text-red-600 bg-red-100 px-2 rounded-xl font-semibold"}>{user?.status}</Texto>
        </div>
        <div className="flex flex-col items-center justify-items-center w-full lg:w-1/2 my-[10px] sm:my-[15px] p-[15px] mx-auto">
          <H3Custom className="font-semibold">FECHA DE CREACIÓN</H3Custom>
          <Texto className="">
            {formatDate(user?.creationDate)}
          </Texto>
        </div>
        <div className="flex flex-col items-center justify-items-center w-full lg:w-3/4 my-[10px] sm:my-[15px] p-[15px] mx-auto">
          <H3Custom className="font-semibold">CLIENTES HABILITADOS</H3Custom>
          {data?.map((client, index) => {
            return (
              <Texto key={index} className="">
                - {client?.name} {client?.fatherLastName} {client?.motherLastName}
              </Texto>
            )
          })}
        </div>
      </div>
    </div>
  )
}
